import { IconType } from 'react-icons';
import styled from 'styled-components';

import { CodeFileExtension } from 'types';

const IconLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 42px;
`;

const Extension = styled.span`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  height: 18px;
`;

const IconView = styled.div`
  display: flex;
  flex: 1;
  align-items: center;

  svg {
    font-size: 32px;
  }
`;

const InfoView = styled.div`
  line-height: 1.2;

  span {
    text-align: left;
  }
`;

const Title = styled.span`
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
`;

const Description = styled.span`
  display: block;
  font-size: 12px;
  color: ${(props) => props.theme.global.lightTextColor};
`;

const Container = styled.button<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid ${({ $isSelected, theme: { global } }) => ($isSelected ? global.mainColor : global.borderColor)};
  border-radius: 4px;
  padding: 12px 16px;
  font-size: 14px;

  ${IconView} {
    svg {
      color: ${({ $isSelected, theme: { global } }) => ($isSelected ? global.mainColor : global.lightTextColor)};
    }
  }

  ${Extension} {
    background-color: ${({ $isSelected, theme: { global } }) =>
      $isSelected ? global.mainColor : global.lightTextColor};
  }

  ${Title} {
    color: ${({ $isSelected, theme: { global } }) => ($isSelected ? global.mainColor : global.lightTextColor)};
  }
`;

interface ExtensionButtonProps {
  extension: CodeFileExtension;
  title: string;
  description: string;
  isSelected: boolean;
  Icon: IconType;
  onClick: () => void;
}

const ExtensionButton = ({ extension, title, description, isSelected, Icon, onClick }: ExtensionButtonProps) => {
  return (
    <Container $isSelected={isSelected} onClick={onClick}>
      <IconLayout>
        <IconView>{<Icon />}</IconView>
        <Extension>{extension.toUpperCase()}</Extension>
      </IconLayout>
      <InfoView>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </InfoView>
    </Container>
  );
};

export default ExtensionButton;
